import { render, staticRenderFns } from "./transImg.vue?vue&type=template&id=583a9546&scoped=true"
import script from "./transImg.vue?vue&type=script&lang=js"
export * from "./transImg.vue?vue&type=script&lang=js"
import style0 from "./transImg.vue?vue&type=style&index=0&id=583a9546&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583a9546",
  null
  
)

export default component.exports